// src/components/Gallery.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Gallery.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Empowering_workspaces from "../assets/gallery/Empowering_workspaces.jpeg";
import Team_Collabration from "../assets/gallery/Team_collabration.jpeg";
import Marathon from "../assets/gallery/Marathon.jpeg";
import Startup_Ecosystem from "../assets/gallery/Startup_Ecosystem.jpeg";
import Team_activities from "../assets/gallery/Team_Activities.png";
import Digital_experience from "../assets/gallery/Digital_experience.jpeg";
import Students_visit1 from "../assets/gallery/Students_visit.png";
import Student_visit2 from "../assets/gallery/Students_visit2.jpeg";

const Gallery = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="gallery-page">
      {/* Close Button */}
      <button className="close-gallery" onClick={() => navigate("/")}>
        ×
      </button>

      <section className="gallery-section" id="gallery">
        {/* Header */}
        <div className="gallery-header" data-aos="fade-up">
          <h2>Life at Venturebiz</h2>
          <p>
            Explore our journey, culture, and the amazing people who make
            Venturebiz thrive. From collaborations to celebrations, here’s a
            glimpse of our dynamic workplace.
          </p>
        </div>

        {/* Carousel */}
        <div className="gallery-carousel" data-aos="fade-up">
          <Carousel
            showThumbs={false}
            infiniteLoop
            autoPlay
            interval={3500}
            showStatus={false}
          >
            <div>
              <img src={Empowering_workspaces} alt="Empowering Workspaces" />
              <p className="legend">Empowering Workspaces</p>
            </div>
            <div>
              <img src={Team_Collabration} alt="Team Collaboration" />
              <p className="legend">Team Collaboration</p>
            </div>
            <div>
              <img src={Marathon} alt="Marathon & Activities" />
              <p className="legend">Marathon & Outdoor Activities</p>
            </div>
          </Carousel>
        </div>

        {/* Info Cards */}
        <div className="modern-info-grid" data-aos="fade-up">
          <div className="info-card">
            <img src={Startup_Ecosystem} alt="Startup Ecosystem" />
            <h3>Company Ecosystem</h3>
            <p>Efficiently manage and scale your IT infrastructure with us.</p>
          </div>
          <div className="info-card">
            <img src={Team_activities} alt="Team Activities" />
            <h3>Team Spotlight</h3>
            <p>Enjoy team-building activities and collaborative projects.</p>
          </div>
          <div className="info-card">
            <img src={Digital_experience} alt="Digital Experience" />
            <h3>Digital Experience</h3>
            <p>We craft engaging digital experiences that drive results.</p>
          </div>
        </div>

        {/* Company Info Section */}
        <div className="company-info-section" data-aos="fade-up">
          <div className="company-images">
            <div className="image-large">
              <img
                src={Students_visit1}
                alt="Student Visit"
                className="intern-image"
              />
            </div>
            <div className="image-small">
              <img
                src={Student_visit2}
                alt="Student Visit"
                className="intern-image"
              />
            </div>
          </div>

          <div className="company-text">
            <h3>Discovering the Power of Technology</h3>
            <p>
              We were delighted to host a group of students for an insightful
              industry visit. The session offered them exposure to real-world IT
              operations and collaborative work.
            </p>
            <p>
              Our team shared valuable experiences, discussed the latest
              technologies, and encouraged young minds to explore tech careers.
            </p>
            <div className="highlight-box modern-highlight">
              <p>Empowering young talent through knowledge and experience.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
